import { useState } from "react";
import { Menu, X } from "lucide-react";

const LINKS = [
  { id: "services", label: "Services" },
  { id: "roles", label: "Roles" },
  { id: "industries", label: "Industries" },
  { id: "how-it-works", label: "How it Works" },
  { id: "calculator", label: "Commission" },
  { id: "trust", label: "Trust" },
];

export const Header = ({ openForm }) => {
  const [open, setOpen] = useState(false);
  const go = (fn) => () => { setOpen(false); fn(); };
  return (
    <header className="sticky top-0 z-50 border-b border-slate-800 bg-slate-900/90 backdrop-blur-md">
      <div className="mx-auto flex max-w-[1360px] items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
        <a href="#top" data-testid="nav-logo" className="mr-auto flex items-center gap-2.5 xl:mr-0">
          <img src="/img/bgr-logo.png" alt="Balangir Group logo" data-testid="nav-logo-img" className="h-12 w-auto shrink-0 object-contain" />
          <span className="leading-none">
            <span className="block font-heading text-lg font-extrabold text-white">Balangir Group</span>
            <span data-testid="nav-logo-domain" className="block whitespace-nowrap text-xs font-bold tracking-wide" style={{ color: "#D4A017" }}>BalangirGroup.com</span>
          </span>
        </a>
        <nav className="ml-8 hidden items-center gap-6 whitespace-nowrap 2xl:flex">
          {LINKS.map((l) => (
            <a key={l.id} href={`#${l.id}`} data-testid={`nav-link-${l.id}`} className="text-sm text-slate-300 transition-colors hover:text-orange-400">{l.label}</a>
          ))}
        </nav>
        <div className="hidden items-center gap-2 whitespace-nowrap pl-6 xl:flex">
          <a href="/book" data-testid="nav-book-cleaning" className="rounded-lg border border-orange-400 bg-orange-500/10 px-3 py-2 text-sm font-semibold text-orange-300 transition-colors hover:bg-orange-500/20">Book Service</a>
          <a href="/employer" data-testid="nav-employer-login" className="rounded-lg border border-white/20 px-3 py-2 text-sm font-medium text-slate-200 transition-colors hover:border-orange-400 hover:text-orange-400">Employer Login</a>
          <a href="/worker" data-testid="nav-worker-login" className="rounded-lg border border-white/20 px-3 py-2 text-sm font-medium text-slate-200 transition-colors hover:border-orange-400 hover:text-orange-400">Employee Login</a>
          <button data-testid="nav-cta-worker" onClick={() => openForm("worker")} className="rounded-lg border border-white/20 px-3 py-2 text-sm font-medium text-slate-200 transition-colors hover:border-orange-400 hover:text-orange-400">Register as Employee</button>
          <button data-testid="nav-cta-hire" onClick={() => openForm("employer")} className="rounded-lg bg-orange-500 px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-orange-600 hover:text-white">Hire Workforce</button>
        </div>
        <button className="order-first mr-3 flex h-12 w-12 items-center justify-center rounded-xl bg-amber-400 text-slate-900 shadow-md hover:bg-amber-500 xl:hidden" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">
          {open ? <X className="h-9 w-9" strokeWidth={2.5} /> : <Menu className="h-9 w-9" strokeWidth={2.5} />}
        </button>
      </div>
      {open && (
        <div data-testid="nav-mobile-menu" className="flex max-h-[80vh] flex-col gap-1.5 overflow-y-auto border-t border-slate-800 px-4 pb-5 pt-3 xl:hidden">
          {[...LINKS.map((l) => ({ key: l.id, href: `#${l.id}`, label: l.label, tid: `nav-mobile-link-${l.id}`, close: true })),
            { key: "book", href: "/book", label: "Book Service", tid: "nav-mobile-book-cleaning", hot: true },
            { key: "employer", href: "/employer", label: "Employer Login", tid: "nav-mobile-employer-login" },
            { key: "worker", href: "/worker", label: "Employee Login", tid: "nav-mobile-worker-login" }].map((l, i) => (
            <a key={l.key} href={l.href} onClick={l.close ? () => setOpen(false) : undefined} data-testid={l.tid}
              className={`flex items-center gap-3 rounded-lg border px-3 py-2.5 ${l.hot ? "border-orange-400 bg-orange-500/10 font-semibold text-orange-300" : "border-white/10 text-slate-200"}`}>
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-amber-400 text-sm font-bold text-slate-900">{i + 1}</span>{l.label}
            </a>
          ))}
          <button data-testid="nav-mobile-cta-hire" onClick={go(() => openForm("employer"))} className="mt-2 rounded-lg bg-orange-500 py-3 font-semibold text-white">Hire Workforce</button>
          <button data-testid="nav-mobile-cta-worker" onClick={go(() => openForm("worker"))} className="rounded-lg border border-white/15 py-3 text-slate-200">Register as Employee</button>
        </div>
      )}
    </header>
  );
};
